import { Injectable } from '@angular/core';
import { SmartIrrigationRootNodeDto } from 'src/api/models';

/** Shared across all node-tree-item instances so a dragged node can be identified by any drop target. */
@Injectable({
  providedIn: 'root'
})
export class NodeDragService {
  draggedNode: SmartIrrigationRootNodeDto | null = null;
}
